var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { title: _vm.language["ispforum.personalize"] } },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", "align-items": "center" } },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.language["ispforum.creativeDisplayAN"]))
          ]),
          _c("a-input", {
            staticStyle: {
              width: "300px",
              "margin-left": "8px",
              "margin-right": "8px"
            },
            attrs: { maxLength: 100 },
            model: {
              value: _vm.nickName,
              callback: function($$v) {
                _vm.nickName = $$v
              },
              expression: "nickName"
            }
          }),
          _c(
            "a-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleNickNameChange }
            },
            [_vm._v(_vm._s(_vm.language["common.confirmButton"]))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }